import { render, staticRenderFns } from "./EmployeeCardUserName.vue?vue&type=template&id=06b9ac75"
import script from "./EmployeeCardUserName.vue?vue&type=script&lang=ts"
export * from "./EmployeeCardUserName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b9ac75')) {
      api.createRecord('06b9ac75', component.options)
    } else {
      api.reload('06b9ac75', component.options)
    }
    module.hot.accept("./EmployeeCardUserName.vue?vue&type=template&id=06b9ac75", function () {
      api.rerender('06b9ac75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeCardUserName.vue"
export default component.exports